import { FormGroup } from "../../../components/form";
import * as Yup from "yup";

export const assignAssessorForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "assignedAssessor",
      label: "Application Assigned to",
      fieldType: "dropdown",
      props: {
        placeholder: "Select an Assessor",
      },
      expressionProps: {
        options: (context) => context.options,
      },
      validation: Yup.string().trim().required("A response is required"),
    },
  ],
};
